export default __webpack_public_path__ + "static/media/documents-icon-active.6e09cfd3.svg";